export default __webpack_public_path__ + "static/media/din-pro--regular.ddf64406.woff";